import React from 'react'
import { Typography } from '@mui/material'
import SelectField from '../../../../../../FormControl/input/SelectField'
import { setParentData } from '../../../../../Assessment/utils'
import { useGroupStudentsContext } from '../../GroupStudentsContext/GroupStudentsContext'

const AssesmentArea = ({ element, elementData, childrenElements = [], form = {}, errors, onChange, parent }) => {
  const value = form[element?.elementStructureId]?.value || []
  const dataSelected = value.length === 1 ? childrenElements?.find((item) => value.includes(item._id)) : null

  return (
    <>
      <div>
        <Typography variant='inherit' className='font-bold capitalize' color='primary' align='right' component='p'>
          {elementData?.name}
        </Typography>
      </div>
      <div className='col-span-2'>
        <SelectField
          id={`${element?.elementStructureId}`}
          name={element?.elementStructureId}     
          className='capitalize'
          error={errors[element?.elementStructureId]}
          helperText={errors[element?.elementStructureId]}                    
          value={value || []}
          onChange={
            (e) => onChange(
              element?.elementStructureId,
              elementData?.name,
              { value: [e.target.value], name: elementData.name, parent, find: childrenElements?.filter((item) => [e.target.value].includes(item._id)) },
              'elementId'
            )
          }      
          options={childrenElements?.map((item) => ({ value: item._id, label: item.name })) || [] }
          placeholder="Choose an option"
        />
      </div>
      { dataSelected?.elements?.map((item) => {
        const elData = elementData?.children?.find((el) => el._id === item.elementStructureId)
        return (
          <AssesmentArea
            key={`${element?.elementStructureId}-${item._id}`}
            element={item}
            childrenElements={item.children}
            form={form[element?.elementStructureId].children}
            errors={errors}
            onChange={onChange}
            elementData={elData}
            parent={setParentData({ _id: element?.elementStructureId }, parent)}
          />
        )
      })}
    </>
  )
}

const FormCurriculumElements = ({ form = {}, onChange }) => {
  const {
    currentCurriculum,
  } = useGroupStudentsContext();
  if (!currentCurriculum || !currentCurriculum?.elements || !currentCurriculum.elementsStructure) return <></>

  return (
    <AssesmentArea
      element={currentCurriculum?.elements}
      elementData={currentCurriculum?.elementsStructure}
      childrenElements={currentCurriculum?.elements?.children}
      form={form}
      errors={{}}
      onChange={onChange}
    />
  )
}

export default FormCurriculumElements